import React from 'react';

export const File = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3.5 3.83325C3.5 2.72868 4.39543 1.83325 5.5 1.83325H7.18421C8.84106 1.83325 10.1842 3.1764 10.1842 4.83325V5.99992C10.1842 7.38063 11.3035 8.49992 12.6842 8.49992H13.5C15.1569 8.49992 16.5 9.84306 16.5 11.4999V16.1666C16.5 17.2712 15.6046 18.1666 14.5 18.1666H5.5C4.39543 18.1666 3.5 17.2712 3.5 16.1666V3.83325Z"
      stroke={color || '#6B778C'}
      strokeWidth="2"
    />
    <path
      d="M3.5 3.83325C3.5 2.72868 4.39543 1.83325 5.5 1.83325H6.99708C9.3569 1.83325 11.5963 2.87512 13.1164 4.68017L14.6193 6.46487C15.8339 7.90724 16.5 9.7323 16.5 11.618V16.1666C16.5 17.2712 15.6046 18.1666 14.5 18.1666H5.5C4.39543 18.1666 3.5 17.2712 3.5 16.1666V3.83325Z"
      stroke={color || '#6B778C'}
      strokeWidth="2"
    />
  </svg>
);
